import { render, staticRenderFns } from "./MatchCleanupComponent.vue?vue&type=template&id=5a89a1a2&scoped=true"
import script from "./MatchCleanupComponent.vue?vue&type=script&lang=js"
export * from "./MatchCleanupComponent.vue?vue&type=script&lang=js"
import style0 from "./MatchCleanupComponent.vue?vue&type=style&index=0&id=5a89a1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89a1a2",
  null
  
)

export default component.exports